import React from "react";

const Loader = () => {
  return (
    <div className="popup_modal loader_container">
      <div className="loader" />
    </div>
  );
};

export default Loader;
